"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleButton = ToggleButton;
var React = _interopRequireWildcard(require("react"));
var _common = require("../../common");
var _Button = require("./Button");
var _excluded = ["buttonStyle", "minimal", "toggled"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ToggleButton(_ref) {
  var buttonStyle = _ref.buttonStyle,
    _ref$minimal = _ref.minimal,
    minimal = _ref$minimal === void 0 ? false : _ref$minimal,
    _ref$toggled = _ref.toggled,
    toggled = _ref$toggled === void 0 ? false : _ref$toggled,
    props = _objectWithoutProperties(_ref, _excluded);
  var toggledButtonStyleMap = {
    primary: _common.ButtonStyle.POSITIVE,
    secondary: _common.ButtonStyle.POSITIVE,
    tertiary: _common.ButtonStyle.POSITIVE
  };
  /**
   * Currently a little bit of a fudge
   * We've had to add some `primary-alt` and `secondary-alt` styles, but we don't want them exposed via `ButtonStyle` (at the moment anyway)
   * For this reason we refer to them with a string
   */
  var minimalToggledButtonStyleMap = {
    primary: 'primary-alt',
    secondary: 'secondary-alt',
    tertiary: 'secondary-alt'
  };
  var calculatedButtonStyle;
  if (toggled) {
    if (minimal) {
      calculatedButtonStyle = minimalToggledButtonStyleMap[buttonStyle];
    } else {
      calculatedButtonStyle = toggledButtonStyleMap[buttonStyle];
    }
  } else {
    calculatedButtonStyle = buttonStyle;
  }
  return /*#__PURE__*/React.createElement(_Button.Button, _extends({}, props, {
    buttonStyle: calculatedButtonStyle
  }));
}